import { ApiService } from "../../../constants/ApiService";
import { HttpService } from "../../../constants/HTTPService";
import { IDataUploadComment } from "../../../interfaces/IDataUploadComment";
import { IDataUploadItem } from "../../../interfaces/IDataUploadItem";

export const getUserTesting = async () => {
  const data = HttpService.get(ApiService.testing.getTestingUser);
  const dataAPI = (await data).data;

  return dataAPI.data;
};

export const getListRequestType = async () => {
  const data = HttpService.get(ApiService.alesaForm.getListRequestType);
  const dataAPI = (await data).data;

  return dataAPI.data;
};

export const getListDocumentType = async () => {
  const data = HttpService.get(ApiService.alesaForm.getListDocumentType);
  const dataAPI = (await data).data;

  return dataAPI.data;
};

export const getListAreaLocation = async () => {
  const data = HttpService.post(
    ApiService.apiHc.getAreaLocation,
    JSON.stringify({
      AreaLocation: { LocationID: "", LocationHierarcyID: "" },
    })
  );
  const dataAPI = (await data).data;

  return dataAPI.data;
};

export const sendHardCopySKByCL = async (
  binusianID?: string,
  dataUploadSK?: IDataUploadItem,
  dataUpload?: IDataUploadItem[],
  requestID?: string,
  requestStatusID?: string
) => {
  const data = HttpService.post(
    ApiService.alesaForm.EditFormCorporateLegalHardCopySK,
    JSON.stringify({
      BinusianID: binusianID,
      ListDocument: dataUpload,
      RequestID: requestID,
      RequestStatusID: requestStatusID,
      FileUploadDocumentHardCopySK: dataUploadSK,
    })
  );
  const dataAPI = (await data).data;

  return dataAPI;
};

export const getSingleDataRequest = async (requestID?: string) => {
  const data = HttpService.post(
    ApiService.alesaForm.getSingleDataRequest,
    JSON.stringify({
      RequestID: requestID,
    })
  );
  const dataAPI = (await data).data;

  return dataAPI.data;
};

export const downloadSingleFile = async (
  documentName?: string,
  category?: string,
  requestID?: string,
  sharepointToken?: string
) => {
  const data = HttpService.post(
    ApiService.alesaForm.downloadSingleFile,
    JSON.stringify({
      DocumentName: documentName,
      Category: category,
      RequestID: requestID,
      SharepointToken: sharepointToken,
    })
  );
  const dataAPI = (await data).data;

  return dataAPI.data;
};

export const getSharepointToken = async () => {
  const data = HttpService.get(ApiService.alesaForm.getSharepointToken);
  const dataAPI = (await data).data;

  return dataAPI.data;
};

export const sendBack = async (
  requestID?: string,
  binusianID?: string,
  comment?: string,
  commentDocument?: IDataUploadComment,
  requestStatusID?: string
) => {
  const data = HttpService.post(
    ApiService.alesaForm.sendBackFromLegalRelationship,
    JSON.stringify({
      RequestID: requestID,
      BinusianID: binusianID,
      Comment: comment,
      FileCommentDocument: commentDocument,
      RequestStatusID: requestStatusID,
    })
  );
  const dataAPI = (await data).data;

  return dataAPI;
};
